import { cn } from "@/shared/lib/cn";

/** Hairline indeterminate spinner for pending states. Honors reduced motion. */
export interface SpinnerProps {
  /** Diameter in px. Default 18. */
  size?: number;
  className?: string;
  label?: string;
}

export function Spinner({ size = 18, className, label }: SpinnerProps) {
  return (
    <span
      role="status"
      aria-label={label}
      style={{ width: size, height: size }}
      className={cn(
        "inline-block animate-spin rounded-full border-2 border-line border-t-ink",
        className,
      )}
    />
  );
}
